/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-door': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M198 56h-96a6 6 0 00-6 6v176a6 6 0 006 6h96a6 6 0 006-6V62a6 6 0 00-6-6zm-2 180h-92V64h92z"/><path pid="1" d="M124 222h52a6 6 0 006-6v-22a6 6 0 00-6-6h-52a6 6 0 00-6 6v22a6 6 0 006 6zm-2-28a2 2 0 012-2h52a2 2 0 012 2v22a2 2 0 01-2 2h-52a2 2 0 01-2-2zM124 172h52a6 6 0 006-6v-56a32 32 0 00-64 0v56a6 6 0 006 6zm-2-62a28 28 0 0156 0v56a2 2 0 01-2 2h-52a2 2 0 01-2-2z"/>'
  }
})
